import React,{useState} from 'react'
import { NavLink, useNavigate, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import Loader from '../../utils/Loader'
import { toast } from 'react-toastify';

const Otp = () => {
    const [otp1, setotp1] = useState('')
    const [otp2, setotp2] = useState('')
    const [otp3, setotp3] = useState('')
    const [otp4, setotp4] = useState('')
    const [counter, setCounter] = useState(59);
    let navigate = useNavigate();
    const userName = useLocation();
    var User = userName.state && userName.state

    const VerifyHandler = ()=>{
        var otp = User?.otp?.otp
        var inputOtp = otp1 + otp2 + otp3 + otp4

        console.log(otp +','+ inputOtp)

        if(otp1 == '')
        {
          toast.error("Field is required");
        } else if(Number(otp) !== Number(inputOtp)){
          toast.error("OTP does not match");
        } else {
          navigate("/reset-password", {state:{user:User}});
        }
        
    }

    let tabChange = function(val){
        let ele = document.querySelectorAll('input');
        if(ele[val-1].value != ''){
          ele[val].focus()
        }else if(ele[val-1].value == ''){
          ele[val-2].focus()
        }   
     }


  return (
    <>
    <div className='top-b-header'>
      <NavLink to="/forgot-password">
      <i className="fa-solid fa-arrow-left"></i>
      </NavLink>
    
      <h3>Verify OTP</h3>
      <div></div>
  </div>
   
    <div className='container'>
    <div className='forgot-screen'>
        <img src='images/otp.png'/>
        <h3>Enter OTP</h3>
        <p>Please enter 4 digit OTP which we have sent to <span style={{color:'#15B9A9'}}>{User?.email}</span></p>
        <div className='form-group'>
        <ul className="otp-l">
                    <li>
                    <input
                  type="text"
                  maxLength="1"
                  onKeyUp={()=>tabChange(1)}
                  className="form-control input-style"
                  placeholder="-"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  value={otp1}
                  onChange={(e) => {
                    setotp1(e.target.value);
                }}
                /> 
                    </li>
                    <li>
                    <input
                  type="text"
                  maxLength="1"
                  onKeyUp={()=>tabChange(2)}
                  className="form-control input-style"
                  placeholder="-"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  value={otp2}
                  onChange={(e) => {
                    setotp2(e.target.value);
                    
                }}
                /> 
                    </li>
                    <li>
                    <input
                  type="text"
                  maxLength="1"
                  onKeyUp={()=>tabChange(3)}
                  className="form-control input-style"
                  placeholder="-"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  value={otp3}
                  onChange={(e) => {
                    setotp3(e.target.value);
                   
                }}
                /> 
                    </li>
                    <li>
                    <input
                  type="text"
                  maxLength="1"
                  onKeyUp={()=>tabChange(4)}
                  className="form-control input-style"
                  placeholder="-"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  value={otp4}
                  onChange={(e) => {
                    setotp4(e.target.value);
                    
                }}
                /> 
                    </li>
                </ul>
        </div>
        <div className='form-group'>
                <button type='button' className='login-btn' onClick={VerifyHandler}>VERIFY</button>
            </div>
    </div>
    </div>
   
    </>
  )
}

export default Otp